<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <div class="form-card-title">{{ $t('工单信息') }}</div>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('工单类型')" prop="ticketsType">
                <a-select v-model="model.ticketsType" :placeholder="$t('请选择工单类型')" @change="ticketsTypeChange" :disabled="model.id ? true : false">
                  <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                  <a-select-option :value="11">{{ $t('水厂报修') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>

          <template v-if="model.ticketsType == 11">
            <!-- 水厂报修 -->
            <!-- 保修- 非系统用户 -->
            <template>
              <a-divider class="aDividerBlue" orientation="left">{{ $t('报修信息') }}</a-divider>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('报修人名称')" prop="repairName">
                    <a-input v-model="model.repairName" :placeholder="$t('请输入报修人名称')"></a-input>
                    <!-- <j-select-user-by-dep v-model="model.repairName" :multi="false" /> -->
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('报修人电话')" prop="repairPhone">
                    <a-input v-model="model.repairPhone" :placeholder="$t('请输入报修人电话')"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('设备信息')" prop="repairAddress">
                    <a-input v-model="model.repairAddress" :placeholder="$t('请输入设备信息')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
            <!-- 报修- 其他信息 -->
            <template>
              <a-divider
                class="aDividerBlue"
                orientation="left"
                >{{ $t('报修信息') }}</a-divider
              >
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                    <j-dict-select-tag
                      v-model="model.ticketsEmergency"
                      :placeholder="$t('请选择工单紧急程度')"
                      dictCode="ticketsEmergency"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :label="$t('报修描述')" prop="repairDescription">
                    <a-textarea v-model="model.repairDescription" :placeholder="$t('请输入报修描述')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('报修图片')" prop="repairPicture">
                    <j-image-upload
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :isMultiple="true"
                      v-model="model.repairPicture"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
            <!-- 报修- 处理信息 -->
            <template>
              <a-divider class="aDividerBlue" orientation="left">{{ $t('处理信息') }}</a-divider>

              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('是否解决')" prop="solveStatus">
                    <a-select v-model="model.solveStatus" :placeholder="$t('请选择是否解决')" @change="handleChangeSolveStatus">
                      <a-select-option :value="1">{{ $t('已解决') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('未解决') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
          
            <!-- 报修 已解决 非系统用户 或者 系统用户不换表  -->
            <a-row v-if=" model.solveStatus == 1">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理前照片')" :prop="'resolvedPictureFront'">
                    <j-image-upload
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :isMultiple="true"
                      v-model="model.resolvedPictureFront"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理后照片')" :prop="'resolvedPictureOpposite'">
                    <j-image-upload
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :isMultiple="true"
                      v-model="model.resolvedPictureOpposite"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <!-- 处理描述其他信息 -->
              <a-row>
                <a-col :span="24">
                  <a-form-model-item :label="$t('处理描述')" prop="handleUserDescription">
                    <a-textarea v-model="model.handleUserDescription" :placeholder="$t('请输入处理描述')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-row>

          </template>

          <!-- 故障报修 -->
          <a-row :gutter="[24, 16]" v-if="model.ticketsType == 2">
            <a-col :span="12">
              <a-form-model-item :label="$t('用户类型')" prop="repairCreateOrderUserType">
                <a-radio-group v-model="model.repairCreateOrderUserType" @change="handleUserTypeChange">
                  <a-radio :value="0">{{ $t('非系统用户') }}</a-radio>
                  <a-radio :value="1">{{ $t('系统用户') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item prop="selectUser" v-if="model.repairCreateOrderUserType == 1">
                <a-button @click="handleAddEquipment" type="primary" icon="plus">{{ $t('选择用户') }}</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
          <!-- 保修- 系统用户 -->
          <template
            v-if="JSON.stringify(meterInfo) != '{}' && model.ticketsType == 2 && model.repairCreateOrderUserType == 1"
          >
            <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
            <detail-list :col="3" v-if="JSON.stringify(meterInfo) != '{}'">
              <detail-list-item :term="$t('用户编号')">{{ meterInfo.userId }}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{ meterInfo.userName }}</detail-list-item>
              <detail-list-item :term="$t('手机号码')">{{ meterInfo.userPhone }}</detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('开户时间')">{{ meterInfo.userCreateTime }}</detail-list-item>
              <detail-list-item :term="$t('用水性质')">{{ meterInfo.wtName }}</detail-list-item>
              <detail-list-item :term="$t('用水状态')">{{
                meterInfo.userState == 0 ? $t('未开始计费') : meterInfo.userState == 1 ? $t('已开始计费') : ''
              }}</detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ meterInfo.userAreaName }}</detail-list-item>
              <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ meterInfo.userAddr }}</detail-list-item>
              <!-- <detail-list-item term="用户地址" :itemCol="1">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
            </detail-list>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('旧表编号')">{{ meterInfo.oldMeterId }}</detail-list-item>
              <!-- <detail-list-item term="用水性质">{{meterInfo.wtName}}</detail-list-item> -->
              <detail-list-item :term="$t('水表厂家')">{{ meterInfo.meterTypeName }}</detail-list-item>
              <detail-list-item :term="$t('口径')"
                >{{ meterInfo.mtCaliber ? 'DN' + meterInfo.mtCaliber : '' }}
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('表计费起始读数')">{{ meterInfo.oldMeterStartNum }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算流量(m³)')">{{ meterInfo.oldUserCalNum }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算余额(元)')">{{ meterInfo.userAccountNum }}</detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('末次上报日期')">{{ meterInfo.meterUpTime }}</detail-list-item>
            </detail-list>
          </template>
          <!-- 保修- 非系统用户 -->
          <template v-if="model.ticketsType == 2 && model.repairCreateOrderUserType == 0">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('报修信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('报修人名称')" prop="repairName">
                  <a-input v-model="model.repairName" :placeholder="$t('请输入报修人名称')"></a-input>
                  <!-- <j-select-user-by-dep v-model="model.repairName" :multi="false" /> -->
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('报修人电话')" prop="repairPhone">
                  <a-input v-model="model.repairPhone" :placeholder="$t('请输入报修人电话')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('报修地址')" prop="repairAddress">
                  <a-input v-model="model.repairAddress" :placeholder="$t('请输入报修地址')"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
          <!-- 报修- 其他信息 -->
          <template v-if="model.ticketsType == 2">
            <a-divider
              class="aDividerBlue"
              orientation="left"
              v-if="model.ticketsType == 2 && model.repairCreateOrderUserType == 1"
              >{{ $t('报修信息') }}</a-divider
            >
            <a-row :gutter="24">
              <!-- <a-col :span="8">
                                <a-form-model-item label="报修时间" prop="repairTime">
                                    <a-date-picker show-time v-model="model.repairTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                                </a-form-model-item>
                            </a-col> -->
              <a-col :span="8">
                <a-form-model-item :label="$t('预约时间')" prop="dealTime">
                  <a-date-picker
                    show-time
                    v-model="model.dealTime"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    style="width: 100%"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <!-- <a-form-model-item label="是否解决" prop="solveStatus">
                                    <a-select v-model="model.solveStatus" placeholder="请选择是否解决">
                                        <a-select-option :value="1">{{ $t('已解决') }}</a-select-option>
                                        <a-select-option :value="0">{{ $t('未解决') }}</a-select-option>
                                    </a-select>
                                </a-form-model-item> -->
                <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                  <j-dict-select-tag
                    v-model="model.ticketsEmergency"
                    :placeholder="$t('请选择工单紧急程度')"
                    dictCode="ticketsEmergency"
                    style="width: 100%"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('报修描述')" prop="repairDescription">
                  <a-textarea v-model="model.repairDescription" :placeholder="$t('请输入报修描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('报修图片')" prop="repairPicture">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.repairPicture"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
          <!-- 报修- 处理信息 -->
          <template v-if="model.ticketsType == 2">
            <a-divider class="aDividerBlue" orientation="left" v-if="model.ticketsType == 2">{{ $t('处理信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('是否解决')" prop="solveStatus">
                  <a-select v-model="model.solveStatus" :placeholder="$t('请选择是否解决')" @change="handleChangeSolveStatus">
                    <a-select-option :value="1">{{ $t('已解决') }}</a-select-option>
                    <a-select-option :value="0">{{ $t('未解决') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="model.solveStatus == 1 && model.repairCreateOrderUserType == 1">
                <a-form-model-item :label="$t('是否换表')" prop="ifNeedChangeMeter">
                  <a-select
                    v-model="model.ifNeedChangeMeter"
                    :placeholder="$t('请选择是否换表')"
                    @change="handleChangeIfNeedChangeMeter"
                  >
                    <a-select-option :value="1">{{ $t('换表') }}</a-select-option>
                    <a-select-option :value="0">{{ $t('不换表') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="8" v-if="model.solveStatus == 1">
                                <a-form-model-item label="选择处理人员" prop="handleUserName">
                                    <a-select v-model="model.handleUserName" placeholder="请选择处理人员">
                                        <a-select-option v-for="item in pList" :value="item.username" :key="item.username">{{item.realname}}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8" v-if="model.solveStatus == 1">
                                <a-form-model-item label="处理时间" prop="handleUserTime">
                                    <a-date-picker show-time v-model="model.handleUserTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                                </a-form-model-item>
                            </a-col> -->
            </a-row>

            <!-- <a-row :gutter="24" v-if="model.solveStatus == 1">
                            <a-col :span="24">
                                <a-form-model-item label="处理描述" prop="handleUserDescription">
                                    <a-textarea v-model="model.handleUserDescription" placeholder="请输入处理描述" :rows="4" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>

                        <a-row :gutter="24" v-if="model.solveStatus == 1">
                            <a-col :span="8">
                            <a-form-model-item label="处理照片" prop="resolvedPicture">
                                <j-image-upload class="avatar-uploader" text="上传" :isMultiple="true" v-model="model.resolvedPicture"></j-image-upload>
                            </a-form-model-item>
                            </a-col>
                        </a-row> -->
          </template>
          <!-- 报修 已解决 系统用户 换表  -->
          <template
            v-if="
              model.ticketsType == 2 &&
              model.solveStatus == 1 &&
              model.repairCreateOrderUserType == 1 &&
              model.ifNeedChangeMeter == 1
            "
          >
            <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>
            <a-button @click="selectNewMeter" type="primary" style="margin-bottom: 10px" icon="plus">{{ $t('选择新表') }}</a-button>
            <detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('新表编号')">{{ model.newMeterId }}</detail-list-item>
                <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                <detail-list-item :term="$t('新表厂商')">{{ model.newMtName }}</detail-list-item>
                <detail-list-item :term="$t('口径')">{{
                  model.newMtCaliber ? 'DN' + model.newMtCaliber : ''
                }}</detail-list-item>
              </detail-list>
            </detail-list>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('旧表机械读数(m³)')" prop="meterOldMachineSumFlow">
                  <a-input-number
                    v-model="model.meterOldMachineSumFlow"
                    :placeholder="$t('请输入旧表机械读数')"
                    style="width: 100%"
                    :min="0"
                    :precision="2"
                    @change="meterOldMachineSumFlowInput"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新表开始计费读数(m³)')" prop="meterStartNum">
                  <a-input-number
                    v-model="model.meterStartNum"
                    :min="0"
                    :precision="2"
                    style="width: 100%"
                    :placeholder="$t('请输入起始读数')"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('处理前照片')" :prop="'resolvedPictureFront'">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.resolvedPictureFront"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('处理后照片')" :prop="'resolvedPictureOpposite'">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.resolvedPictureOpposite"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('是否以旧表机械读数结算')" prop="whetherSettlementOldTable">
                  <a-select
                    v-model="model.whetherSettlementOldTable"
                    :placeholder="$t('请选择是否以旧表机械读数结算')"
                    :allowClear="true"
                    @change="whetherSettlementOldTableChange"
                  >
                    <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                    <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item :label="$t('是否收费')" prop="payOrNot">
                  <a-select v-model="model.payOrNot" :placeholder="$t('请选择是否收费')" @change="payOrNotChange">
                    <a-select-option :value="1">{{ $t('收费') }}</a-select-option>
                    <a-select-option :value="0">{{ $t('不收费') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('剩余金额(元)')" prop="meterUserAccountNumAfterChange">
                  <a-input-number
                    v-model="model.meterUserAccountNumAfterChange"
                    :precision="2"
                    style="width: 100%"
                    :placeholder="$t('请输入剩余金额')"
                    :disabled="model.whetherSettlementOldTable == 1 ? true : false"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('换表原因')" prop="changingMeterReason">
                  <a-cascader
                    :options="options"
                    v-model="changingMeterReason"
                    expand-trigger="hover"
                    :placeholder="$t('请选择换表原因')"
                    @change="onChange"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12" v-if="model.payOrNot == 1">
                <a-form-model-item :label="$t('付款码')" prop="paymentCode">
                  <a-upload
                    action=""
                    list-type="picture-card"
                    :file-list="qrcodeImage"
                    @preview="handlePreview"
                    disabled
                  >
                  </a-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="model.payOrNot == 1">
                <a-form-model-item :label="$t('支付凭证')" prop="infoPicture">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.infoPicture"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="model.payOrNot == 1">
                <a-form-model-item :label="$t('收费金额(元)')" prop="feeAmount">
                  <a-input-number
                  v-model="model.feeAmount"
                  :precision="2"
                  :min="0"
                  style="width: 100%"
                  :placeholder="$t('请输入收费金额')"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="model.payOrNot == 1">
                <a-form-model-item :label="$t('协议书照片')" prop="protocolPicture">
                  <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  :isMultiple="true"
                  v-model="model.protocolPicture"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="24">
                <a-form-model-item :label="$t('处理描述')" prop="handleUserDescription">
                  <a-textarea v-model="model.handleUserDescription" :placeholder="$t('请输入处理描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>

          <!-- 报修 已解决 非系统用户 或者 系统用户不换表  -->
          <a-row
            v-if="
              model.ticketsType == 2 &&
              model.solveStatus == 1 &&
              (model.repairCreateOrderUserType == 0 || model.ifNeedChangeMeter == 0)
            "
          >
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('处理前照片')" :prop="'resolvedPictureFront'">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.resolvedPictureFront"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('处理后照片')" :prop="'resolvedPictureOpposite'">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="model.resolvedPictureOpposite"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- 处理描述其他信息 -->
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label="$t('处理描述')" prop="handleUserDescription">
                  <a-textarea v-model="model.handleUserDescription" :placeholder="$t('请输入处理描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-row>

          <!-- 换表     -->
          <div v-if="model.ticketsType == 0">
            <a-row :gutter="[24, 16]">
              <a-col :span="24">
                <a-form-model-item prop="selectUser">
                  <a-button @click="handleAddEquipment" type="primary" icon="plus">{{ $t('选择用户') }}</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
            <template v-if="equipmentVisible && model.ticketsType == 0">
              <div>
                <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
                <detail-list :col="3" v-if="JSON.stringify(meterInfo) != '{}'">
                  <detail-list-item :term="$t('用户编号')">{{ meterInfo.userId }}</detail-list-item>
                  <detail-list-item :term="$t('用户姓名')">{{ meterInfo.userName }}</detail-list-item>
                  <detail-list-item :term="$t('手机号码')">{{ meterInfo.userPhone }}</detail-list-item>
                </detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('开户时间')">{{ meterInfo.userCreateTime }}</detail-list-item>
                  <detail-list-item :term="$t('用水性质')">{{ meterInfo.wtName }}</detail-list-item>
                  <detail-list-item :term="$t('用水状态')">{{
                    meterInfo.userState == 0 ? $t('未开始计费') : meterInfo.userState == 1 ? $t('已开始计费') : ''
                  }}</detail-list-item>
                </detail-list>

                <detail-list :col="3">
                  <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ meterInfo.userAreaName }}</detail-list-item>
                  <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ meterInfo.userAddr }}</detail-list-item>
                  <!-- <detail-list-item term="用户地址" :itemCol="1">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
                </detail-list>

                <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表信息') }}</a-divider>
                <detail-list :col="3">
                  <detail-list-item :term="$t('旧表编号')">{{ meterInfo.oldMeterId }}</detail-list-item>
                  <!-- <detail-list-item term="用水性质">{{meterInfo.wtName}}</detail-list-item> -->
                  <detail-list-item :term="$t('水表厂家')">{{ meterInfo.meterTypeName }}</detail-list-item>
                  <detail-list-item :term="$t('口径')"
                    >{{ meterInfo.mtCaliber ? 'DN' + meterInfo.mtCaliber : '' }}
                  </detail-list-item>
                </detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('表计费起始读数')">{{ meterInfo.oldMeterStartNum }}</detail-list-item>
                  <detail-list-item :term="$t('末次上报结算流量(m³)')">{{ meterInfo.oldUserCalNum }}</detail-list-item>
                  <detail-list-item :term="$t('末次上报结算余额(元)')">{{ meterInfo.userAccountNum }}</detail-list-item>
                </detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('末次上报日期')">{{ meterInfo.meterUpTime }}</detail-list-item>
                </detail-list>
                <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item :label="$t('预约时间')" prop="dealTime">
                      <a-date-picker
                        show-time
                        v-model="model.dealTime"
                        valueFormat="YYYY-MM-DD HH:mm:ss"
                        style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                      <j-dict-select-tag
                        v-model="model.ticketsEmergency"
                        :placeholder="$t('请选择工单紧急程度')"
                        dictCode="ticketsEmergency"
                        style="width: 100%"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-model-item v-if="model.meterSolveStatus == 0" :label="$t('换表原因')" prop="changingMeterReason">
                      <a-select v-model="model.changingMeterReason" :placeholder="$t('请选择换表原因')">
                        <a-select-option :value="0">{{ $t('周期性换表') }}</a-select-option>
                        <a-select-option :value="1">{{ $t('故障换表') }}</a-select-option>
                      </a-select>
                      <!-- <j-dict-select-tag v-model="model.changingMeterReason" placeholder="请选择换表原因" dictCode="meterChangeType" /> -->
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :span="24">
                    <a-form-model-item :label="$t('备注信息')" prop="changingMeterReasonDetail">
                      <a-textarea :placeholder="$t('备注信息')" v-model="model.changingMeterReasonDetail" :rows="4" />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-divider class="aDividerBlue" orientation="left">{{ $t('处理信息') }}</a-divider>
                <a-row :gutter="24">
                  <a-col :span="8">
                    <a-form-model-item :label="$t('是否补录')" prop="meterSolveStatus">
                      <a-select
                        v-model="model.meterSolveStatus"
                        :placeholder="$t('请选择是否补录')"
                        @change="handleChangeMeterSolveStatus"
                      >
                        <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                        <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <!-- 换表 补录 -->
                <template v-if="model.ticketsType == 0 && model.meterSolveStatus == 1">
                  <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>
                  <a-button style="margin-bottom: 10px" type="primary" icon="plus" @click="selectNewMeter">
                    {{ $t('选择新表') }}
                  </a-button>
                  <detail-list>
                    <detail-list :col="3">
                      <detail-list-item :term="$t('新表编号')">{{ model.newMeterId }}</detail-list-item>
                      <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                      <detail-list-item :term="$t('新表厂商')">{{ model.newMtName }}</detail-list-item>
                      <detail-list-item :term="$t('口径')">{{
                        model.newMtCaliber ? 'DN' + model.newMtCaliber : ''
                      }}</detail-list-item>
                    </detail-list>
                  </detail-list>

                  <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item :label="$t('旧表机械读数(m³)')" prop="meterOldMachineSumFlow">
                        <a-input-number
                          v-model="model.meterOldMachineSumFlow"
                          :placeholder="$t('请输入旧表机械读数')"
                          style="width: 100%"
                          :min="0"
                          :precision="2"
                          @change="meterOldMachineSumFlowInput"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item :label="$t('新表开始计费读数(m³)')" prop="meterStartNum">
                        <a-input-number
                          v-model="model.meterStartNum"
                          :min="0"
                          :precision="2"
                          style="width: 100%"
                          :placeholder="$t('请输入起始读数')"
                        />
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item :label="$t('旧表照片')" :prop="'resolvedPictureFront'">
                        <j-image-upload
                          class="avatar-uploader"
                          :text="$t('上传')"
                          :isMultiple="true"
                          v-model="model.resolvedPictureFront"
                        ></j-image-upload>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item :label="$t('新表照片')" :prop="'resolvedPictureOpposite'">
                        <j-image-upload
                          class="avatar-uploader"
                          :text="$t('上传')"
                          :isMultiple="true"
                          v-model="model.resolvedPictureOpposite"
                        ></j-image-upload>
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item :label="$t('是否以旧表机械读数结算')" prop="whetherSettlementOldTable">
                        <a-select
                          v-model="model.whetherSettlementOldTable"
                          :placeholder="$t('请选择是否以旧表机械读数结算')"
                          @change="whetherSettlementOldTableChange"
                          :allowClear="true"
                        >
                          <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                          <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                      <a-form-model-item :label="$t('是否收费')" prop="payOrNot">
                        <a-select v-model="model.payOrNot" :placeholder="$t('请选择是否收费')" @change="payOrNotChange">
                          <a-select-option :value="1">{{ $t('收费') }}</a-select-option>
                          <a-select-option :value="0">{{ $t('不收费') }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item :label="$t('剩余金额(元)')" prop="meterUserAccountNumAfterChange">
                        <a-input-number
                          v-model="model.meterUserAccountNumAfterChange"
                          :precision="2"
                          style="width: 100%"
                          :placeholder="$t('请输入剩余金额')"
                          :disabled="model.whetherSettlementOldTable == 1 ? true : false"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item :label="$t('换表原因')" prop="changingMeterReason">
                        <a-cascader
                          :options="options"
                          v-model="changingMeterReason"
                          expand-trigger="hover"
                          :placeholder="$t('请选择换表原因')"
                          @change="onChange"
                        />
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row :gutter="24">
                    <a-col :span="12" v-if="model.payOrNot == 1">
                      <a-form-model-item :label="$t('付款码')" prop="paymentCode">
                        <a-upload
                          action=""
                          list-type="picture-card"
                          :file-list="qrcodeImage"
                          @preview="handlePreview"
                          disabled
                        >
                        </a-upload>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="model.payOrNot == 1">
                      <a-form-model-item :label="$t('支付凭证')" prop="infoPicture">
                        <j-image-upload
                          class="avatar-uploader"
                          :text="$t('上传')"
                          :isMultiple="true"
                          v-model="model.infoPicture"
                        ></j-image-upload>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="model.payOrNot == 1">
                      <a-form-model-item :label="$t('收费金额(元)')" prop="feeAmount">
                        <a-input-number
                        v-model="model.feeAmount"
                        :precision="2"
                        :min="0"
                        style="width: 100%"
                        :placeholder="$t('请输入收费金额')"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="model.payOrNot == 1">
                      <a-form-model-item :label="$t('协议书照片')" prop="protocolPicture">
                        <j-image-upload
                        class="avatar-uploader"
                        :text="$t('上传')"
                        :isMultiple="true"
                        v-model="model.protocolPicture"
                        ></j-image-upload>
                      </a-form-model-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item :label="$t('换表原因描述')" prop="remark">
                        <a-textarea v-model="model.remark" :placeholder="$t('请输入处理描述')" :rows="4" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </template>
              </div>
            </template>
          </div>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal
      :title="$t('选择用户')"
      :width="1200"
      :visible="equipmentModalVisible"
      :maskClosable="false"
      @ok="handleOk1"
      @cancel="handleCancel1"
      :okText="$t('确定')"
      :cancelText="$t('关闭')"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户电话')">
                <a-input :placeholder="$t('用户电话查询')" v-model="queryParam.userPhone"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户地址')">
                <j-input :placeholder="$t('用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          :bordered="false"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ x: 'max-content' }"
          :customRow="customRow"
          :rowSelection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :components="drag(columns)"
          @change="handleTableChange"
        >
        </a-table>
      </div>
    </j-modal>
    <!-- 选择新表弹窗 -->
    <SelectNewMeterModal
      :visible="selectNewMeterModalVisible"
      @update:visible="val => (selectNewMeterModalVisible = val)"
      @ok="handleMeterSelected"
    />
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel2">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </j-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { PhoneNumberPattern, CardIdNumberPattern } from '@/utils/regPattern'
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JInput from '@/components/jeecg/JInput'
import Vue from 'vue'
import { USER_INFO } from "@/store/mutation-types"
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import SelectNewMeterModal from './selectNewMeter.vue'
import TableDragResize from '@/mixins/TableDragResize'
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import {fileUrl} from'@/utils/util'
export default {
  mixins: [JeecgListMixin, TableDragResize],
  name: 'workModal',
  components: {
    DetailList,
    DetailListItem,
    JUpload,
    JImageUpload,
    JInput,
    JSelectUserByDep,
    SelectNewMeterModal,
  },
  data() {
    return {
      title: '',
      ticketsFrom: 'Ticket', // 工单来源 默认Ticket（工单） Inspection（巡检）UserOA（OA）
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      selectNewMeterModalVisible: false,
      qrcodeImage: [
        {
          uid: '-1',
          name: '付款码',
          status: 'done',
          url: fileUrl+'/file/payment_code.png',
        }
      ],
      previewVisible: false,
      previewImage: '',
      selectedMeter: null,
      model: {
        repairCreateOrderUserType: 0, // 保修 建单 用户来源
        installationDetail: {},
        meterUserAccountNumAfterChange: null,
        whetherSettlementOldTable: '',
        infoPicture: '',
      },
      url: {
        add: '/jeecg-engineering/ticket/tickets/createTicket',
        edit: '/jeecg-engineering/ticket/tickets/newUpdate',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        list: '/jeecg-charge/meter/meterUserinfo/list',
        flowlist: '/jeecg-engineering/flowable/definition/list',
        meterInfo: '/jeecg-charge/meter/meterUserinfo/queryUserDetailInfoById',
        userType: '/jeecg-charge/meter/meterUserType/list',
        getUseAndMoneyByMeterId: '/jeecg-charge/meter/meterUpData/getUseAndMoneyByMeterId',
        useOldMachineSumFlow: '/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow', //是否以旧表读数结算
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId', //换表请求
        userList: '/sys/user/list',
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', //新表接口
      },
      flowList: [],
      nodeUserVisible: false,
      userVisible: false,
      equipmentVisible: false,
      equipmentModalVisible: false,
      dataSource: [],
      meterInfo: {},
      meterUserInfoByKey: {},
      clientTypeList: [],
      fileList: [],
      pList: [],
      oldMeter: {},
      newMeter: {},
      changingMeterReason: [],
    }
  },
  computed: {
    validatorRules() {
      return {
        ticketsType: [{ required: true, message: this.$t('请选择工单类型'), trigger: 'change' }],
        // ticketsLocation: [{required:true,message:'请输入地理信息',trigger:'blur'}],
        //   ticketsContact: [{required:true,message:'请输入工单联系人',trigger:'blur'}],
        //   ticketsContactPhone: [{required:true,message:'请输入联系电话',trigger:'blur'},{pattern: PhoneNumberPattern,message: '请输入正确的手机号码'}],
        ticketsEmergency: [{ required: true, message: this.$t('请选择紧急程度'), trigger: 'change' }],
        // ticketsDeadline: [{required:true,message:'请选择截止时间',trigger:'change'}],
        // ticketsTransaction: [{required:true,message:'请输入事务分类',trigger:'blur'}],
        // 工程报装
        installationType: [{ required: true, message: this.$t('请选择报装类型'), trigger: 'change' }],
        clientName: [{ required: true, message: this.$t('请输入用户名称') }],
        repairCreateOrderUserType: [{ required: true, message: this.$t('请输入用户类型') }],
        waterAddress: [{ required: true, message: this.$t('请输入用水地址') }],
        identificationNumber: [
          { required: true, message: this.$t('请输入用户身份证号') },
          { pattern: CardIdNumberPattern, message: this.$t('请输入正确的身份证号') },
        ],
        phone: [
          { required: true, message: this.$t('请输入用户联系电话') },
          { pattern: PhoneNumberPattern, message: this.$t('请输入正确的手机号码') },
        ],
        clientType: [{ required: true, message: this.$t('请选择用户类别') }],
        waterType: [{ required: true, message: this.$t('请选择用水类别') }],
        emergency: [{ required: true, message: this.$t('请选择紧急程度') }],
        createName: [{ required: true, message: this.$t('请输入联系人') }],
        createPhone: [
          { required: true, message: this.$t('请输入创建人电话') },
          { pattern: PhoneNumberPattern, message: this.$t('请输入正确的手机号码') },
        ],
        repairName: [{ required: false, message: this.$t('请输入报修人名称') }],
        repairPhone: [
          { required: false, message: this.$t('请输入报修人电话') },
          { pattern: PhoneNumberPattern, message: this.$t('请输入正确的手机号码') },
        ],
        repairAddress: [{ required: true, message: this.$t('请输入信息') }],
        repairTime: [{ required: false, message: this.$t('请选择报修时间') }],
        repairPicture: [{ required: false, message: this.$t('请上传报修图片') }],
        resolvedPictureFront: [{ required: true, message: this.$t('请上传处理前图片') }],
        resolvedPictureOpposite: [{ required: true, message: this.$t('请上传处理后图片') }],
        repairDescription: [{ required: true, message: this.$t('请输入报修描述') }],
        solveStatus: [{ required: true, message: this.$t('请选择是否解决') }],
        meterSolveStatus: [{ required: true, message: this.$t('请选择是否补录') }],
        handleUserName: [{ required: true, message: this.$t('请选择处理人员') }],
        handleUserTime: [{ required: true, message: this.$t('请选择处理时间') }],
        handleUserDescription: [{ required: true, message: this.$t('请输入处理描述') }],
        // fixPicture: [{ required: true, message: '请选择修理图片' },],
        fixPhone: [
          { required: true, message: this.$t('请输入修理人员电话') },
          { pattern: PhoneNumberPattern, message: this.$t('请输入正确的手机号码') },
        ],
        fixDescription: [{ required: true, message: this.$t('请输入修理人员描述') }],
        meterOldMachineSumFlow: [{ required: true, message: this.$t('请输入旧表机械读数') }],
        changingMeterReason: [{ required: true, message: this.$t('请选择换表原因') }],
        meterUserAccountNumAfterChange: [{ required: false, message: this.$t('请输入换表后账户剩余金额') }],
        whetherSettlementOldTable: [{ required: false, message: this.$t('请选择是否以旧表机械读数结算') }],
        meterStartNum: [{ required: true, message: this.$t('请输入新表开始计费读数') }],
        payOrNot: [{ required: false, message: this.$t('请选择是否收费') }],
        ifNeedChangeMeter: [{ required: true, message: this.$t('请选择是否换表') }],
        infoPicture: [{ required: true, message: this.$t('请上传支付凭证') }],
        remark: [{ required: true, message: this.$t('请输入换表原因描述') }],
        feeAmount: [{ required: true, message: this.$t('请输入收费金额') }],
        protocolPicture: [{ required: true, message: this.$t('请上传协议书照片') }],
        // selectUser: [{ required: true, message: '请选择用户' },],
      }
    },
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          align: 'center',
          dataIndex: 'userId',
          width: 150,
          ellipsis: true,
        },
        // {
        //   title:'区域名称',
        //   align:"center",
        //   dataIndex:'userAreaName',
        //   width:200,
        //   ellipsis: true
        // },
        {
          title: this.$t('用户姓名'),
          align: 'center',
          dataIndex: 'userName',
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          align: 'center',
          dataIndex: 'meterTypeName',
          width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('用户地址'),
          align: 'center',
          dataIndex: 'userAddr',
          customRender: (t, r, index) => {
            if (r.userAreaName) {
              let i = r.userAreaName.indexOf('-')
              return r.userAreaName.slice(i + 1, r.userAreaName.length) + '-' + t
            } else {
              return t
            }
          },
          width: 350,
          ellipsis: true,
        },
      ]
    },
    options() {
      const t = this.$t
      return [
        {
          value: '0',
          label: t('周期性换表'),
        },
        {
          value: '1',
          label: t('故障换表'),
          children: [
            {
              value: '2',
              label: t('基表问题'),
              children: [
                {
                  value: '3',
                  label: t('计量问题'),
                },
                {
                  value: '4',
                  label: t('阀门故障'),
                },
                {
                  value: '5',
                  label: t('基表爆裂'),
                },
              ],
            },
            {
              value: '6',
              label: t('电子问题'),
              children: [
                {
                  value: '7',
                  label: t('不上传数据'),
                },
                {
                  value: '8',
                  label: t('水表无反应（黑屏，无法激活）'),
                },
              ],
            },
            {
              value: '9',
              label: t('磁干扰'),
            },
            {
              value: '10',
              label: t('缺电'),
            },
            {
              value: '11',
              label: t('其他'),
            },
          ],
        },
      ]
    },
  },
  created() {
    this.getUserType()
  },
  watch: {
    'model.ticketsType': {
      handler(val) {
        // if(val == 1){
        this.meterInfo = {}
        this.equipmentVisible = false
        this.selectedRowKeys = []
        this.model.installationType = 1
        // }
      },
    },
    'model.ticketsContact': {
      handler(val) {
        this.$set(this.model, 'createName', val)
      },
    },
    'model.ticketsContactPhone': {
      handler(val) {
        this.$set(this.model, 'createPhone', val)
      },
    },
    'model.handleUserName': {
      handler(val) {
        if (val) {
          var info = this.pList.find(item => item.username == val)
          this.$set(this.model, 'handleUserRealName', info?.realname ? info.realname : '')
          this.$set(this.model, 'handleUserPhone', info?.telephone || info?.phone)
        }
      },
    },
  },
  methods: {
    getPersonnelList() {
      this.pList = []
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.pList = res.result.records
        }
      })
    },
    uploadChange(file) {
      this.model.annex = file
      this.$refs.form.validateField('annex')
    },
    getUserType() {
      this.clientTypeList = []
      getAction(this.url.userType).then(res => {
        if (res.success) {
          res.result.records.map(item => {
            this.clientTypeList.push({
              utName: item.utName,
              id: item.id,
            })
          })
        }
      })
    },
    init() {
      this.model = {
        installationDetail: {},
        ticketsEmergency: '0',
        meterSolveStatus: 0,
        solveStatus: 0,
        whetherSettlementOldTable: '',
      }
      this.fileList = []
      this.meterInfo = {}
    },
    add() {
      this.visible = true
      this.disableSubmit = false
      this.title = this.$t('新增')
      this.init()
      this.equipmentVisible = false
      this.userVisible = false
      this.getFlowList()
      this.getPersonnelList()
    },
    edit(record, type) {
      let that = this
      this.visible = true
      this.init()
      if (type == 'edit') {
        this.title = this.$t('编辑')
        this.disableSubmit = false
      } else {
        this.title = this.$t('详情')
        this.disableSubmit = true
      }
      let recordNew = JSON.parse(JSON.stringify(record))
      getAction(this.url.queryById, { id: record.id }).then(val => {
        if (val.success) {
          that.model = {
            ...val.result,
            ...recordNew,
          }
          if (that.model.ticketsType == 1) {
            that.model = Object.assign({}, that.model, {
              bzId: that.model.installationDetail.id,
              installationType: that.model.installationDetail.installationType,
              clientName: that.model.installationDetail.clientName,
              waterAddress: that.model.installationDetail.waterAddress,
              identificationNumber: that.model.installationDetail.identificationNumber,
              phone: that.model.installationDetail.phone,
              clientType: that.model.installationDetail.clientType,
              waterType: that.model.installationDetail.waterType,
              emergency: that.model.installationDetail.emergency,
              createName: that.model.installationDetail.createName,
              createPhone: that.model.installationDetail.createPhone,
              reasonapplication: that.model.installationDetail.reasonapplication,
              watersupply: that.model.installationDetail.watersupply,
              isDrain: that.model.installationDetail.isDrain,
              contractCode: that.model.installationDetail.contractCode,
              caliberReport: that.model.installationDetail.caliberReport,
              pipelineLengthSpecifications: that.model.installationDetail.pipelineLengthSpecifications,
              cost: that.model.installationDetail.cost,
              annex: that.model.installationDetail.annex,
              picture: that.model.installationDetail.picture,
            })
            that.model.id = recordNew.id
            if (that.model.annex) that.fileList = [that.model.annex]
          } else if (that.model.ticketsType == 2 || that.model.ticketsType == 11) {
            // 报修
            that.model = Object.assign({}, that.model, {
              bzId: that.model.wechatMeterRepair.id,
              // 报修人信息
              repairName: that.model.wechatMeterRepair.repairName,
              repairPhone: that.model.wechatMeterRepair.repairPhone,
              repairAddress: that.model.wechatMeterRepair.repairAddress,
              repairTime: that.model.wechatMeterRepair.repairTime,
              repairPicture: that.model.repairPicture,
              repairDescription: that.model.wechatMeterRepair.repairDescription,
              // 预约时间
              dealTime: that.model.ticketsDeadline,

              // 是否解决
              solveStatus: that.model.wechatMeterRepair.isSolve,
              // 处理人
              handleUserName: that.model.wechatMeterRepair.handleUserName,
              handleUserRealName: that.model.wechatMeterRepair.handleUserRealName,
              handleUserPhone: that.model.wechatMeterRepair.handleUserPhone,
              handleUserDescription: that.model.wechatMeterRepair.handleUserDescription,
              handleUserTime: that.model.wechatMeterRepair.handleUserTime,
              resolvedPictureFront: that.model.resolvedPictureFront,
              resolvedPictureOpposite: that.model.resolvedPictureOpposite,

              // fixPhone: that.model.wechatMeterRepair.fixPhone,
              // fixDescription: that.model.wechatMeterRepair.fixDescription,
              // fixPicture: that.model.wechatMeterRepair.fixPicture,
              userId: that.model.wechatMeterRepair.userId,
              userName: that.model.wechatMeterRepair.userName,
              userIdNumber: that.model.wechatMeterRepair.userIdNumber,
              mtName: that.model.wechatMeterRepair.mtName,
              userPhone: that.model.wechatMeterRepair.userPhone,
              meterId: that.model.wechatMeterRepair.meterId,
            })
            that.model.id = recordNew.id
            // 如果当前存在 换表结构体 并且有 用户 与 新旧表id
            if (that.model.wechatMeterRepair && that.model.wechatMeterRepair.userId) {
              // 系统用户
              this.$set(that.model, 'repairCreateOrderUserType', 1)
              // 查询系统用户绑定的 旧表信息
              getAction(this.url.list, { userId: that.model.wechatMeterRepair.userId }).then(res => {
                if (res.success && res.result.records.length > 0) {
                  that.meterInfo = res.result.records[0] || {}
                  this.$set(that.meterInfo, 'userId', that.model.wechatMeterRepair.userId)
                  this.$set(that.meterInfo, 'oldMeterId', that.meterInfo.meterId)
                  this.$set(that.meterInfo, 'userKeyId', that.meterInfo.id)
                  that.setOldMeterNum()
                } else {
                  getAction(this.url.list, {
                    userId: that.formData.model.ticketsChangeMeter.userId,
                    isStop: 1,
                  }).then(res => {
                    if (res.success && res.result.records.length > 0) {
                      that.meterInfo = res.result.records[0]
                      that.setOldMeterNum()
                    } else {
                      that.setOldMeterNum()
                    }
                  })
                }
                getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.meterInfo.userKeyId }).then(res => {
                  if (res.success) {
                    this.$set(that.meterInfo, 'oldUserCalNum', res.result.userCalNum)
                    this.$set(that.model, 'oldUserCalNum', res.result.userCalNum)
                    this.$set(that.meterInfo, 'userAccountNum', res.result.userAccountNum)
                    this.$set(that.model, 'userAccountNum', res.result.userAccountNum)
                    this.$set(that.model, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
                    this.$set(that.meterInfo, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
                    // this.$set(this.model, 'meterUserAccountNumAfterChange', res.result.userAccountNum)
                    this.$set(that.model, 'meterOldSumFlowAfterChange', res.result.meterTotalUse)
                    this.$set(that.meterInfo, 'meterUpTime', res.result.meterUpTime)
                  }
                })
              })

              // 是否换表
              if (that.model.ticketsChangeMeter) {
                if (that.model.ticketsChangeMeter.newMeterId) {
                  // 换表
                  this.$set(that.model, 'ifNeedChangeMeter', 1)
                  if (that.model.ticketsChangeMeter.changingMeterReason != null) {
                    this.$set(that.model, 'changingMeterReason', that.model.ticketsChangeMeter.changingMeterReason)
                    // 将后端返回的最后一层值转换为完整路径
                    const fullPath = that.findCascaderPath(that.model.ticketsChangeMeter.changingMeterReason)
                    that.changingMeterReason = fullPath
                  }
                  // 新表数据
                  let params = {
                    meterId: that.model.ticketsChangeMeter.newMeterId,
                  }
                  getAction(this.url.newMeterInfo, params).then(res => {
                    if (res.success) {
                      let selectedMeter = res.result.records[0]
                      // 新表编号 新表口径 新表厂商 新表开始计费读数
                      this.$set(that.model, 'newMeterId', selectedMeter.meterId)
                      this.$set(that.model, 'newMtCaliber', selectedMeter.mtCaliber)
                      this.$set(that.model, 'newMtName', selectedMeter.mtName)
                      this.$set(that.model, 'meterStartNum', that.model.ticketsChangeMeter.meterStartNum)
                      // 是否收费
                      if (that.model.infoPicture) {
                        this.$set(that.model, 'payOrNot', 1)
                        this.$set(that.model, 'feeAmount', that.model.ticketsChangeMeter.feeAmount)
                        this.$set(that.model, 'protocolPicture', that.model.ticketsChangeMeter.protocolPicture)
                      } else {
                        this.$set(that.model, 'payOrNot', 0)
                      }
                    }
                  })
                } else {
                  // 不需要换表
                  this.$set(that.model, 'ifNeedChangeMeter', 0)
                }
              } else {
                // 不需要换表
                this.$set(that.model, 'ifNeedChangeMeter', 0)
              }
            } else {
              // 非系统用户
              this.$set(that.model, 'repairCreateOrderUserType', 0)
            }
            /*
                        that.$nextTick(() => {
                            if (that.model.wechatMeterRepair.source == 1) {
                                var arr = JSON.parse(that.model.wechatMeterRepair.repairPicture);
                                this.$set(that.model, 'repairPicture', arr.join(','));
                            } else {
                                that.$set(that.model, 'repairPicture', that.model.wechatMeterRepair.repairPicture)
                                // that.$set(that.model,'fixPicture',that.model.wechatMeterRepair.fixPicture)
                            }
                        })
*/
            this.getPersonnelList()
          } else {
            // 换表
            that.model = Object.assign({}, that.model, {
              meterOldMachineSumFlow: that.model.ticketsChangeMeter.meterOldMachineSumFlow,
              changingMeterReason: that.model.ticketsChangeMeter.changingMeterReason,
              meterOldSumFlowAfterChange: that.model.ticketsChangeMeter.meterOldSumFlowAfterChange,
              whetherSettlementOldTable: that.model.ticketsChangeMeter.whetherSettlementOldTable,
              meterUserAccountNumAfterChange: that.model.ticketsChangeMeter.meterUserAccountNumAfterChange,
              changingMeterReasonDetail: that.model.ticketsChangeMeter.changingMeterReasonDetail,
              oldUserCalNum: that.model.ticketsChangeMeter.oldUserCalNum,
              oldMeterStartNum: that.model.ticketsChangeMeter.oldMeterStartNum,
              userId: that.model.ticketsChangeMeter.userId,
              userKeyId: that.model.ticketsChangeMeter.userKeyId,
              oldMeterId: that.model.ticketsChangeMeter.oldMeterId,
              userAccountNum: that.model.ticketsChangeMeter.userAccountNum,
              dealTime: that.model.ticketsDeadline,
              // 是否补录
              meterSolveStatus: that.model.ticketsChangeMeter.isSolve,
              meterUpTime: that.model.ticketsChangeMeter.meterUpTime,
              selectUser: true,
              remark: that.model.ticketsChangeMeter.remark,
              feeAmount: that.model.ticketsChangeMeter.feeAmount,
              protocolPicture: that.model.ticketsChangeMeter.protocolPicture,
            })

            if (that.model.ticketsChangeMeter.changingMeterReason != null) {
              this.$set(that.model, 'changingMeterReason', that.model.ticketsChangeMeter.changingMeterReason)
              // 将后端返回的最后一层值转换为完整路径
              const fullPath = that.findCascaderPath(that.model.ticketsChangeMeter.changingMeterReason)
              that.changingMeterReason = fullPath
            }
            that.setOldMeterNum()

            getAction(this.url.list, { userId: this.model.user.userId }).then(res => {
              if (res.success) {
                getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.model.ticketsChangeMeter.userKeyId }).then(res1 => {
                  if (res1.success) {
                    that.meterInfo = {
                      ...res.result.records[0],
                      oldMeterId: that.model.ticketsChangeMeter.oldMeterId,
                    }
                    this.$set(that.meterInfo, 'oldUserCalNum', res1.result.userCalNum)
                    this.$set(that.meterInfo, 'userAccountNum', res1.result.userAccountNum)
                    this.$set(that.meterInfo, 'oldMeterStartNum', that.meterInfo.userMeterStartNum)
                    this.$set(that.meterInfo, 'meterUpTime', res1.result.meterUpTime)
                    if(that.model.id&&that.model.meterSolveStatus==1){
                      that.meterInfo = {
                        ...res.result.records[0],
                        oldMeterId: that.model.ticketsChangeMeter.oldMeterId,
                        oldUserCalNum: that.model.ticketsChangeMeter.oldUserCalNum,
                        userAccountNum: that.model.ticketsChangeMeter.userAccountNum,
                        oldMeterStartNum: that.model.ticketsChangeMeter.oldMeterStartNum,
                        meterUpTime: that.model.ticketsChangeMeter.meterUpTime,
                      }
                    }
                  }
                })
                that.userVisible = true
                that.equipmentVisible = true
                console.log('当前信息', that.meterInfo)
              }

              let meterId = ''
              if (that.model.ticketsState == -1) {
                meterId = that.model.ticketsChangeMeter.newMeterId
              } else {
                meterId = that.model.ticketsChangeMeter.oldMeterId
              }
              // 获取旧表信息
              getAction(that.url.newMeterInfo, { meterId: meterId }).then(res => {
                if (res.success && res.result.records[0] != null) {
                  // 旧表信息
                  this.$set(that.meterInfo, 'meterTypeName', res.result.records[0].mtName || '')
                  this.$set(that.meterInfo, 'mtCaliber', res.result.records[0].mtCaliber || '')
                }
              })
            })

            // 如果是补录换表单 获取新表信息
            if (that.model.meterSolveStatus == 1 && that.model.ticketsChangeMeter.newMeterId != null) {
              // 新表数据
              let params = {
                meterId: that.model.ticketsChangeMeter.newMeterId,
              }
              getAction(this.url.newMeterInfo, params).then(res => {
                if (res.success) {
                  let selectedMeter = res.result.records[0]
                  // 新表编号 新表口径 新表厂商 新表开始计费读数
                  this.$set(that.model, 'newMeterId', selectedMeter.meterId)
                  this.$set(that.model, 'newMtCaliber', selectedMeter.mtCaliber)
                  this.$set(that.model, 'newMtName', selectedMeter.mtName)
                  this.$set(that.model, 'meterStartNum', that.model.ticketsChangeMeter.meterStartNum)
                  // 是否收费
                  if (that.model.infoPicture) {
                    this.$set(that.model, 'payOrNot', 1)
                  } else {
                    this.$set(that.model, 'payOrNot', 0)
                  }
                }
              })
            }
          }
        }
      })

      this.getFlowList()
    },
    setOldMeterNum() {
      if (this.model.ticketsChangeMeter && this.model.ticketsChangeMeter.whetherSettlementOldTable) {
        // 是否旧表结算
        this.$set(this.model, 'whetherSettlementOldTable', this.model.ticketsChangeMeter.whetherSettlementOldTable)
      } else {
        this.$set(this.model, 'whetherSettlementOldTable', '')
      }
      if (this.model.ticketsChangeMeter && this.model.ticketsChangeMeter.meterOldMachineSumFlow) {
        // 旧表机械读数
        this.$set(this.model, 'meterOldMachineSumFlow', this.model.ticketsChangeMeter.meterOldMachineSumFlow)
      }
      if (this.model.ticketsChangeMeter && this.model.ticketsChangeMeter.meterUserAccountNumAfterChange) {
        // 剩余金额
        this.$set(
          this.model,
          'meterUserAccountNumAfterChange',
          this.model.ticketsChangeMeter.meterUserAccountNumAfterChange
        )
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 换表 选择系统用户
      if (this.model.ticketsType == 0 && Object.keys(this.meterInfo).length === 0) {
        this.$message.warning(this.$t('请选择系统用户信息'))
        return
      }
      // 报修单 系统用户 选择系统用户
      if (this.model.repairCreateOrderUserType == 1 && Object.keys(this.meterInfo).length === 0) {
        this.$message.warning(this.$t('请选择系统用户信息'))
        return
      }
      // 报修 系统用户 换表换表
      if (
        this.model.ticketsType == 2 &&
        this.model.solveStatus == 1 &&
        this.model.repairCreateOrderUserType == 1 &&
        this.model.ifNeedChangeMeter == 1 &&
        this.model.newMeterId == ''
      ) {
        this.$message.warning(this.$t('请选择新表数据'))
        return
      }
      // 报修 系统用户 换表换表
      if (this.model.ticketsType == 0 && this.model.meterSolveStatus == 1 && this.model.newMeterId == '') {
        this.$message.warning(this.$t('请选择新表数据'))
        return
      }
      // 判断当前是新增 还是 编辑
      if (!this.model.id) {
        //  新增 保存操作
        this.handleAddOK()
      } else {
        // 编辑 保存 操作
        this.handleEditOK()
      }
    },
    handleCancel() {
      this.close()
    },
    // 新增 保存操作
    handleAddOK() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = this.url.add
          let method = 'post'
          let message = this.$t('新增成功')

          console.log('this.model', this.model)

          let changeMeterParam = {}
          let repairParam = {}
          // 报修
          if (that.model.ticketsType == 2 || that.model.ticketsType == 11) {
            repairParam = JSON.parse(JSON.stringify(that.model))
            // 报修
            this.$set(repairParam, 'ticketsFrom', this.ticketsFrom)
            this.$set(repairParam, 'ticketsState', that.model.ticketsState)
            this.$set(repairParam, 'userKeyId', that.model.userKeyId)
            this.$set(repairParam, 'userId', that.model.userId)
            this.$set(repairParam, 'ticketsDeadline', that.model.dealTime)
            // this.$set(params,'ifNeedChangeMeter',that.model.ifNeedChangeMeter);// 是否换表
            // this.$set(params,'repairPicture',that.model.repairPicture);// 报修照片
            // this.$set(params,'resolvedPicture',that.model.resolvedPicture);// 处理照片
            this.$set(repairParam, 'infoPicture', that.model.infoPicture) // 支付凭证
            // 系统用户
            if (that.model.repairCreateOrderUserType) {
              this.$set(repairParam, 'ticketsContact', that.meterInfo.userName)
              this.$set(repairParam, 'ticketsContactPhone', that.meterInfo.userPhone)
            } else {
              this.$set(repairParam, 'ticketsContact', that.model.repairName)
              this.$set(repairParam, 'ticketsContactPhone', that.model.repairPhone)
            }
            repairParam.ticketsRepairReq = {
              id: that.model.bzId ? that.model.bzId : '',
              repairName: that.model.repairName,
              repairPhone: that.model.repairPhone,
              repairAddress: that.model.repairAddress,
              repairTime: that.model.repairTime,
              repairPicture: that.model.repairPicture,
              repairDescription: that.model.repairDescription,
              solveStatus: that.model.solveStatus,
              // fixPhone: that.model.fixPhone,
              // fixDescription: that.model.fixDescription,
              // fixPicture: that.model.fixPicture,
              handleUserName: that.model.handleUserName,
              handleUserRealName: that.model.handleUserRealName,
              handleUserPhone: that.model.handleUserPhone,
              handleUserDescription: that.model.handleUserDescription,
              handleUserTime: that.model.handleUserTime,
              resolvedPictureFront: that.resolvedPictureFront, // 处理照片
              resolvedPictureOpposite: that.resolvedPictureOpposite, // 处理照片
              userId: that.model.userId,
              userName: that.model.userName,
              userIdNumber: that.model.userIdNumber,
              mtName: that.model.mtName,
              userPhone: that.model.userPhone,
              ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
              /*
                            meterId: that.model.meterId, // 旧表ID
                            repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                            ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                            whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                            meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                            meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                            oldPicture: that.model.oldPicture, // 旧表照片
                            newMeterId:  that.model.newMeterId, // 新表ID
                            newPicture: that.model.newPicture, // 新表照片
                            meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                            payOrNot: that.model.payOrNot, // 是否收费
                            resolvedPicture: that.model.resolvedPicture, // 支付凭证
                            repairRemark: that.model.repairRemark, // 最后的备注
                            */
            }
            repairParam.ticketsChangeMeterReq = {
              oldMeterBalances: this.meterInfo.oldMeterBalances,
              changingMeterReason: that.model.changingMeterReason,
              changingMeterReasonDetail: that.model.changingMeterReasonDetail,
              meterTotalUse: '',
              meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
              meterOldSumFlowAfterChange: that.model.meterOldSumFlowAfterChange,
              userKeyId: that.model.userKeyId,
              userId: that.model.userId,
              meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
              whetherSettlementOldTable: that.model.whetherSettlementOldTable, // 是否以旧表机械读数结算
              oldMeterId: that.model.meterId, // 旧表ID
              oldPicture: that.model.oldPicture, // 旧表照片
              newMeterId: that.model.newMeterId, // 新表ID
              newPicture: that.model.newPicture, // 新表照片
              meterStartNum: that.model.meterStartNum, // 新表开始计费读数
              payOrNot: that.model.payOrNot, // 是否收费
              infoPicture: that.model.infoPicture, // 支付凭证
              repairRemark: that.model.repairRemark, // 最后的备注
              // oldMeterStartNum: that.model.oldMeterStartNum,
              // userAccountNum: that.model.userAccountNum,
              // oldUserCalNum: that.model.oldUserCalNum,
              // meterUpTime: that.meterInfo.meterUpTime,
            }
            console.log('当前this.model数据', that.model)
            console.log('当前报修提交数据', repairParam)
            if(that.model.ifNeedChangeMeter==1&&that.model.solveStatus==1){
              repairParam.ticketsChangeMeterReq.oldMeterStartNum = that.model.oldMeterStartNum;
              repairParam.ticketsChangeMeterReq.userAccountNum = that.model.userAccountNum;
              repairParam.ticketsChangeMeterReq.oldUserCalNum = that.model.oldUserCalNum;
              repairParam.ticketsChangeMeterReq.meterUpTime = that.meterInfo.meterUpTime;
            }
            if(that.model.payOrNot==1){
              repairParam.ticketsChangeMeterReq.feeAmount = that.model.feeAmount;
              repairParam.ticketsChangeMeterReq.protocolPicture = that.model.protocolPicture;
            }
          } else {
            // 换表
            if (this.model.meterSolveStatus == 0) {
              this.handleChangeMeterSolveStatusInit()
            }
            changeMeterParam = {
              ticketsFrom: that.ticketsFrom,
              ticketsType: that.model.ticketsType,
              ticketsEmergency: that.model.ticketsEmergency,
              dealTime: that.model.dealTime,
              ticketsDeadline: that.model.dealTime,
              installationDetail: that.model.installationDetail,
              wechatMeterRepair: that.model.wechatMeterRepair,
              ticketsState: that.model.ticketsState,
              ticketsContact: that.meterInfo.userName,
              ticketsContactPhone: that.meterInfo.userPhone,

              resolvedPictureFront: that.model.resolvedPictureFront,
              resolvedPictureOpposite: that.model.resolvedPictureOpposite,
              infoPicture: that.model.infoPicture,

              ticketsChangeMeterReq: {
                oldMeterBalances: this.meterInfo.oldMeterBalances,
                changingMeterReason: that.model.changingMeterReason,
                changingMeterReasonDetail: that.model.changingMeterReasonDetail,
                meterTotalUse: '',
                meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange,
                meterOldSumFlowAfterChange: that.model.meterOldSumFlowAfterChange,
                userKeyId: that.model.userKeyId,
                userId: that.model.userId,
                meterOldMachineSumFlow: that.model.meterOldMachineSumFlow,
                whetherSettlementOldTable: that.model.whetherSettlementOldTable,
                oldMeterId: that.model.oldMeterId,
                newMeterId: that.model.newMeterId,
                resolvedPictureFront: that.model.resolvedPictureFront,
                resolvedPictureOpposite: that.model.resolvedPictureOpposite,
                infoPicture: that.model.infoPicture,
                remark: that.model.remark, // 换表原因描述
                meterStartNum: that.model.meterStartNum,
                solveStatus: that.model.meterSolveStatus,
                // oldMeterStartNum: that.model.oldMeterStartNum,
                // userAccountNum: that.model.userAccountNum,
                // oldUserCalNum: that.model.oldUserCalNum,
                // meterUpTime: that.meterInfo.meterUpTime,
              },
            }
            if(that.model.meterSolveStatus==1){
              changeMeterParam.ticketsChangeMeterReq.oldMeterStartNum = that.model.oldMeterStartNum;
              changeMeterParam.ticketsChangeMeterReq.userAccountNum = that.model.userAccountNum;
              changeMeterParam.ticketsChangeMeterReq.oldUserCalNum = that.model.oldUserCalNum;
              changeMeterParam.ticketsChangeMeterReq.meterUpTime = that.meterInfo.meterUpTime;
            }
            if(that.model.payOrNot==1){
              changeMeterParam.ticketsChangeMeterReq.feeAmount = that.model.feeAmount;
              changeMeterParam.ticketsChangeMeterReq.protocolPicture = that.model.protocolPicture;
            }
          }
          if (that.model.ticketsType == 0) {
            // 换表
            httpAction(httpurl, changeMeterParam, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(message)
                  that.$emit('ok')
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          } else {
            // 报修
            httpAction(httpurl, repairParam, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(message)
                  that.$emit('ok')
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    // 编辑 保存 操作
    handleEditOK() {
      const that = this
      if (this.model.repairCreateOrderUserType == 1 && Object.keys(this.meterInfo).length === 0) {
        this.$message.warning(this.$t('请选择系统用户信息'))
        return
      }
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = this.url.edit
          let method = 'put'
          let message = this.$t('编辑成功')

          console.log('this.model', this.model)
          let params = JSON.parse(JSON.stringify(that.model))
          let changeMeterParam = {}
          // 报装
          if (that.model.ticketsType == 1) {
            params.installationDetail = {
              id: params.bzId ? params.bzId : '',
              installationType: params.installationType,
              clientName: params.clientName,
              waterAddress: params.waterAddress,
              identificationNumber: params.identificationNumber,
              phone: params.phone,
              clientType: params.clientType,
              waterType: params.waterType,
              emergency: params.emergency,
              createName: params.createName,
              createPhone: params.createPhone,
              reasonapplication: params.reasonapplication,
              watersupply: params.watersupply,
              isDrain: params.isDrain,
              contractCode: params.contractCode,
              caliberReport: params.caliberReport,
              pipelineLengthSpecifications: params.pipelineLengthSpecifications,
              cost: params.cost,
              annex: params.annex,
              picture: params.picture,
            }
          } else if (that.model.ticketsType == 2 || that.model.ticketsType == 11) {
            // 报修
            this.$set(params, 'ticketsFrom', this.ticketsFrom)
            this.$set(params, 'ticketsState', that.model.ticketsState)
            this.$set(params, 'userKeyId', that.model.userKeyId)
            this.$set(params, 'userId', that.model.userId)
            this.$set(params, 'ticketsDeadline', that.model.dealTime)
            // this.$set(params,'ifNeedChangeMeter',that.model.ifNeedChangeMeter);// 是否换表
            // this.$set(params,'repairPicture',that.model.repairPicture);// 报修照片
            // this.$set(params,'resolvedPicture',that.model.resolvedPicture);// 处理照片
            this.$set(params, 'infoPicture', that.model.infoPicture) // 支付凭证
            this.model.user = {}
            // 系统用户
            if (that.model.repairCreateOrderUserType) {
              this.$set(params, 'ticketsContact', that.meterInfo.userName)
              this.$set(params, 'ticketsContactPhone', that.meterInfo.userPhone)
            } else {
              this.$set(params, 'ticketsContact', that.model.repairName)
              this.$set(params, 'ticketsContactPhone', that.model.repairPhone)
            }
            params.ticketsRepairReq = {
              id: params.bzId ? params.bzId : '',
              repairName: params.repairName,
              repairPhone: params.repairPhone,
              repairAddress: params.repairAddress,
              repairTime: params.repairTime,
              repairPicture: params.repairPicture,
              repairDescription: params.repairDescription,
              solveStatus: params.solveStatus,
              // fixPhone: params.fixPhone,
              // fixDescription: params.fixDescription,
              // fixPicture: params.fixPicture,
              handleUserName: params.handleUserName,
              handleUserRealName: params.handleUserRealName,
              handleUserPhone: params.handleUserPhone,
              handleUserDescription: params.handleUserDescription,
              handleUserTime: params.handleUserTime,
              resolvedPictureFront: that.resolvedPictureFront, // 处理照片
              resolvedPictureOpposite: that.resolvedPictureOpposite, // 处理照片
              userId: params.userId,
              userName: params.userName,
              userIdNumber: params.userIdNumber,
              mtName: params.mtName,
              userPhone: params.userPhone,
              ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
              /*
                            meterId: params.meterId, // 旧表ID
                            repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                            ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                            whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                            meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                            meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                            oldPicture: that.model.oldPicture, // 旧表照片
                            newMeterId:  that.model.newMeterId, // 新表ID
                            newPicture: that.model.newPicture, // 新表照片
                            meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                            payOrNot: that.model.payOrNot, // 是否收费
                            resolvedPicture: that.model.resolvedPicture, // 支付凭证
                            repairRemark: that.model.repairRemark, // 最后的备注
                            */
            }
            params.ticketsChangeMeterReq = {
              oldMeterBalances: this.meterInfo.oldMeterBalances,
              changingMeterReason: params.changingMeterReason,
              changingMeterReasonDetail: params.changingMeterReasonDetail,
              userAccountNum: params.userAccountNum,
              meterTotalUse: '',
              oldMeterStartNum: params.oldMeterStartNum,
              oldUserCalNum: params.oldUserCalNum,
              meterUserAccountNumAfterChange: params.meterUserAccountNumAfterChange, // 剩余金额(元)
              meterOldSumFlowAfterChange: params.meterOldSumFlowAfterChange,
              userKeyId: params.userKeyId,
              userId: params.userId,
              meterOldMachineSumFlow: params.meterOldMachineSumFlow, // 旧表机械读数
              whetherSettlementOldTable: params.whetherSettlementOldTable, // 是否以旧表机械读数结算
              oldMeterId: params.meterId, // 旧表ID
              oldPicture: that.model.oldPicture, // 旧表照片
              newMeterId: that.model.newMeterId, // 新表ID
              newPicture: that.model.newPicture, // 新表照片
              meterStartNum: that.model.meterStartNum, // 新表开始计费读数
              payOrNot: that.model.payOrNot, // 是否收费
              infoPicture: that.model.infoPicture, // 支付凭证
              repairRemark: that.model.repairRemark, // 最后的备注
              meterUpTime: that.meterInfo.meterUpTime,
            }
            console.log('当前this.model数据', that.model)
            console.log('当前报修提交数据', params)
            if(that.model.payOrNot==1){
              params.ticketsChangeMeterReq.feeAmount = that.model.feeAmount;
              params.ticketsChangeMeterReq.protocolPicture = that.model.protocolPicture;
            }
          } else {
            // 换表
            changeMeterParam = {
              ticketsFrom: that.ticketsFrom,
              ticketsType: that.model.ticketsType,
              ticketsEmergency: that.model.ticketsEmergency,
              dealTime: that.model.dealTime,
              installationDetail: that.model.installationDetail,
              wechatMeterRepair: that.model.wechatMeterRepair,
              ticketsState: that.model.ticketsState,
              ticketsContact: that.meterInfo.userName,
              ticketsContactPhone: that.meterInfo.userPhone,

              resolvedPictureFront: that.model.resolvedPictureFront,
              resolvedPictureOpposite: that.model.resolvedPictureOpposite,
              infoPicture: that.model.infoPicture,

              ticketsChangeMeterReq: {
                oldMeterBalances: this.meterInfo.oldMeterBalances,
                changingMeterReason: params.changingMeterReason,
                changingMeterReasonDetail: params.changingMeterReasonDetail,
                userAccountNum: params.userAccountNum,
                meterTotalUse: '',
                oldMeterStartNum: params.oldMeterStartNum,
                oldUserCalNum: params.oldUserCalNum,
                meterUserAccountNumAfterChange: params.meterUserAccountNumAfterChange,
                meterOldSumFlowAfterChange: params.meterOldSumFlowAfterChange,
                userKeyId: params.userKeyId,
                userId: params.userId,
                meterOldMachineSumFlow: params.meterOldMachineSumFlow,
                whetherSettlementOldTable: params.whetherSettlementOldTable,
                oldMeterId: params.oldMeterId,
                newMeterId: that.model.newMeterId,
                resolvedPictureFront: that.model.resolvedPictureFront,
                resolvedPictureOpposite: that.model.resolvedPictureOpposite,
                infoPicture: that.model.infoPicture,
                remark: that.model.remark, // 处理备注
                meterStartNum: that.model.meterStartNum,
                solveStatus: params.meterSolveStatus,
                meterUpTime: that.meterInfo.meterUpTime,
              },
            }

            // 换表
            changeMeterParam = {
              ...that.model,
              ticketsFrom: this.ticketsFrom,
              ticketsContact: that.meterInfo.userName,
              ticketsContactPhone: that.meterInfo.userPhone,

              ticketsType: that.model.ticketsType,
              ticketsEmergency: that.model.ticketsEmergency,
              dealTime: that.model.dealTime,
              installationDetail: that.model.installationDetail,
              wechatMeterRepair: that.model.wechatMeterRepair,
              ticketsState: that.model.ticketsState,

              resolvedPictureFront: that.model.resolvedPictureFront,
              resolvedPictureOpposite: that.model.resolvedPictureOpposite,
              infoPicture: that.model.infoPicture,

              ticketsChangeMeterReq: {
                oldMeterBalances: this.meterInfo.oldMeterBalances,
                changingMeterReason: params.changingMeterReason,
                changingMeterReasonDetail: params.changingMeterReasonDetail,
                userAccountNum: params.userAccountNum,
                meterTotalUse: '',
                oldMeterStartNum: params.oldMeterStartNum,
                oldUserCalNum: params.oldUserCalNum,
                meterUserAccountNumAfterChange: params.meterUserAccountNumAfterChange,
                meterOldSumFlowAfterChange: params.meterOldSumFlowAfterChange,
                userKeyId: params.userKeyId,
                userId: params.userId,
                meterOldMachineSumFlow: params.meterOldMachineSumFlow,
                whetherSettlementOldTable: params.whetherSettlementOldTable,
                oldMeterId: params.oldMeterId,
                newMeterNum: '',
                oldMeterUse: '',
                oldMeterMoney: '',

                newMeterId: that.model.newMeterId,
                resolvedPictureFront: that.model.resolvedPictureFront,
                resolvedPictureOpposite: that.model.resolvedPictureOpposite,
                infoPicture: that.model.infoPicture,
                remark: that.model.remark, // 处理备注
                meterStartNum: that.model.meterStartNum,
                solveStatus: params.meterSolveStatus,
                meterUpTime: that.meterInfo.meterUpTime,
              },
            }
            if(that.model.payOrNot==1){
              changeMeterParam.ticketsChangeMeterReq.feeAmount = that.model.feeAmount;
              changeMeterParam.ticketsChangeMeterReq.protocolPicture = that.model.protocolPicture;
            }
          }
          if (that.model.ticketsType == 0) {
            // 换表
            httpAction(httpurl, changeMeterParam, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(message)
                  that.$emit('ok')
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          } else {
            // 报修
            httpAction(httpurl, params, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(message)
                  that.$emit('ok')
                  this.visible = false
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    // 添加设备信息
    handleAddEquipment() {
      this.equipmentModalVisible = true
      this.queryParam.userState = '1'
    },
    // 用户信息
    handleShowUser() {
      this.userVisible = !this.userVisible
    },
    // 节点审批人
    handleNodeUser() {
      this.nodeUserVisible = !this.nodeUserVisible
    },
    handleCancel1() {debugger
      this.equipmentModalVisible = false
    },
    customRow(record, index) {
      return {
        on: {
          click: e => {
            this.selectedRowKeys = [e.currentTarget.dataset.rowKey]
          },
        },
      }
    },
    handleOk1() {
      if (!(this.selectedRowKeys.length > 0)) {
        return this.$message.warning(this.$t('请选择用户！'))
      }
      if (this.model.ticketsType == 0) {
        // 换表
        this.meterInfo = this.dataSource.find(item => item.id == this.selectedRowKeys[0])
        this.$set(this.meterInfo, 'oldMeterId', this.meterInfo.meterId)
        this.$set(this.model, 'oldMeterId', this.meterInfo.meterId)
        this.$set(this.model, 'meterTypeName', this.meterInfo.meterTypeName)
        this.$set(this.model, 'userId', this.meterInfo.userId)
        this.$set(this.model, 'userKeyId', this.meterInfo.id)
        // this.$set(this.model,'meterUserAccountNumAfterChange',this.meterInfo.userAccountNum);
        // this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userStartCalNum)
        this.$set(this.model, 'userAddr', this.meterInfo.userAddr)
        // this.$set(this.model,'meterOldSumFlowAfterChange',this.meterInfo.meterTotalUse);
        this.$set(this.model, 'whetherSettlementOldTable', '')
        // userCreateTime 用户开户时间
        //meterTypeName 水表厂商
        // mtCaliber 口径
        // wtName 用水性质
        // oldMeterStartNum 旧表开始读数
        this.$set(this.model, 'userCreateTime', this.meterInfo.userCreateTime)
        this.$set(this.model, 'meterTypeName', this.meterInfo.meterTypeName)
        this.$set(this.model, 'mtCaliber', this.meterInfo.mtCaliber)
        this.$set(this.model, 'wtName', this.meterInfo.wtName)
        this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
        //
        getAction(this.url.getMeterUserInfoByKeyId, { userKeyId: this.meterInfo.id }).then(res => {
          if (res.success) {
            this.$set(this.meterInfo, 'oldUserCalNum', res.result.userCalNum)
            this.$set(this.model, 'oldUserCalNum', res.result.userCalNum)
            this.$set(this.meterInfo, 'userAccountNum', res.result.userAccountNum)
            this.$set(this.model, 'userAccountNum', res.result.userAccountNum)
            this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
            this.$set(this.meterInfo, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
            // this.$set(this.model, 'meterUserAccountNumAfterChange', res.result.userAccountNum)
            this.$set(this.model, 'meterOldSumFlowAfterChange', res.result.meterTotalUse)
            this.$set(this.meterInfo, 'meterUpTime', res.result.meterUpTime)
          }
        })
        this.equipmentModalVisible = false
        this.equipmentVisible = true
        this.$set(this.model, 'selectUser', true)
        this.$nextTick(() => {
          this.$refs.form.validateField('selectUser')
        })
      } else {
        // 报修
        this.meterInfo = this.dataSource.find(item => item.id == this.selectedRowKeys[0])

        this.$set(this.meterInfo, 'oldMeterId', this.meterInfo.meterId)
        this.$set(this.model, 'oldMeterId', this.meterInfo.meterId)
        this.$set(this.model, 'userId', this.meterInfo.userId)
        this.$set(this.model, 'userKeyId', this.meterInfo.id)
        // this.$set(this.model,'meterUserAccountNumAfterChange',this.meterInfo.userAccountNum);
        // this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userStartCalNum)
        this.$set(this.model, 'userAddr', this.meterInfo.userAddr)
        // this.$set(this.model,'meterOldSumFlowAfterChange',this.meterInfo.meterTotalUse);
        this.$set(this.model, 'whetherSettlementOldTable', '')
        // userCreateTime 用户开户时间
        //meterTypeName 水表厂商
        // mtCaliber 口径
        // wtName 用水性质
        // oldMeterStartNum 旧表开始读数
        this.$set(this.model, 'userCreateTime', this.meterInfo.userCreateTime)
        this.$set(this.model, 'meterTypeName', this.meterInfo.meterTypeName)
        this.$set(this.model, 'mtCaliber', this.meterInfo.mtCaliber)
        this.$set(this.model, 'wtName', this.meterInfo.wtName)
        this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)

        this.$set(this.model, 'userName', this.meterInfo.userName)
        this.$set(this.model, 'userIdNumber', this.meterInfo.userIdNumber)
        this.$set(this.model, 'mtName', this.meterInfo.mtName)
        this.$set(this.model, 'userPhone', this.meterInfo.userPhone)
        this.$set(this.model, 'meterId', this.meterInfo.meterId)
        getAction(this.url.getMeterUserInfoByKeyId, { userKeyId: this.meterInfo.id }).then(res => {
          if (res.success) {
            this.$set(this.meterInfo, 'oldUserCalNum', res.result.userCalNum)
            this.$set(this.model, 'oldUserCalNum', res.result.userCalNum)
            this.$set(this.meterInfo, 'userAccountNum', res.result.userAccountNum)
            this.$set(this.model, 'userAccountNum', res.result.userAccountNum)
            this.$set(this.model, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
            this.$set(this.meterInfo, 'oldMeterStartNum', this.meterInfo.userMeterStartNum)
            // this.$set(this.model, 'meterUserAccountNumAfterChange', res.result.userAccountNum)
            this.$set(this.model, 'meterOldSumFlowAfterChange', res.result.meterTotalUse)
            this.$set(this.meterInfo, 'meterUpTime', res.result.meterUpTime)
          }
        })
        this.equipmentModalVisible = false
        this.$set(this.model, 'selectUser', true)
        this.$nextTick(() => {
          this.$refs.form.validateField('selectUser')
        })
      }
    },
    // 获取工单流程列表
    getFlowList() {
      this.flowList = []
      getAction(this.url.flowlist, {
        column: 'createTime',
        order: 'desc',
        field: 'id,,id,key,category,name,version,suspensionState,deploymentTime,action',
        pageNo: 1,
        pageSize: 10,
        isLastVersion: 1,
        suspensionState: 0,
      }).then(res => {
        res.result.records.forEach(re => {
          this.flowList.push({
            key: re.key,
            name: re.name,
          })
        })
      })
    },
    meterOldMachineSumFlowInput() {
      if (this.model.whetherSettlementOldTable == 1) {
        let params = {
          meterOldMachineSumFlow: this.model.meterOldMachineSumFlow,
          userId: this.model.userId,
          meterIdOld: this.model.oldMeterId,
          userKeyId: this.model.userKeyId,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.model, 'meterUserAccountNumAfterChange', res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    onRadioChnage(e) {
      if (e.target.value == 1) {
        let params = {
          meterOldMachineSumFlow: this.model.meterOldMachineSumFlow,
          userId: this.model.userId,
          meterIdOld: this.model.oldMeterId,
          userKeyId: this.model.userKeyId,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.model, 'meterUserAccountNumAfterChange', res.result)
          }
        })
      }
    },
    // 选择新表
    selectNewMeter() {
      this.selectNewMeterModalVisible = true
    },
    handleMeterSelected(selectedMeter) {
      this.selectedMeter = selectedMeter
      // 新表编号
      this.model.newMeterId = selectedMeter.meterId
      // 新表口径
      this.model.newMtCaliber = selectedMeter.mtCaliber
      // 新表厂商 =
      this.model.newMtName = selectedMeter.mtName

      console.log('选中的表信息:', selectedMeter)
      // 这里可以处理选中的表信息，比如保存到父组件的数据中
    },
    handleUserTypeChange(value) {
      // 非系统用户
      this.$set(this.model, 'repairName', '')
      this.$set(this.model, 'repairPhone', '')
      this.$set(this.model, 'repairAddress', '')

      this.model.userId = null
      // 非系统用户 初始化 系统用户值
      this.meterInfo = {}
      this.$set(this.model, 'solveStatus', 0)
      this.handleChangeSolveStatus()
      // 清空表单校验
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 切换 是否解决 初始化
    handleChangeSolveStatus() {
      this.$set(this.model, 'handleUserDescription', '')
      this.$set(this.model, 'resolvedPictureFront', '')
      this.$set(this.model, 'resolvedPictureOpposite', '')
      this.$set(this.model, 'ifNeedChangeMeter', 0)
      this.handleChangeIfNeedChangeMeter()
    },
    // 切换 是否换表 初始化
    handleChangeIfNeedChangeMeter() {
      this.$set(this.model, 'meterOldMachineSumFlow', '')
      this.$set(this.model, 'whetherSettlementOldTable', '')
      this.$set(this.model, 'meterUserAccountNumAfterChange', '')

      // 新表数据初始化
      this.$set(this.model, 'newMeterId', '')
      this.$set(this.model, 'newMtCaliber', '')
      this.$set(this.model, 'newMtName', '')
      this.$set(this.model, 'meterStartNum', '')
      this.$set(this.model, 'payOrNot', 0)
      this.$set(this.model, 'infoPicture', '')
    },
    // 切换是否补录 初始化
    handleChangeMeterSolveStatus() {
      debugger
      // 换表原因 置空
      this.$set(this.model, 'changingMeterReason', '')
      this.$set(this.model, 'infoPicture', '') // 支付凭证
      // 换表原因 置空
      this.initNewMeter()
      this.initChangeMeterOption()
    },
    // 切换是否补录 初始化
    handleChangeMeterSolveStatusInit() {
      // 换表原因 置空
      this.initNewMeter()
      this.initChangeMeterOption()
    },
    // 初始化 新表数据
    initNewMeter() {
      // 新表数据初始化
      this.$set(this.model, 'newMeterId', '')
      this.$set(this.model, 'newMtCaliber', '')
      this.$set(this.model, 'newMtName', '')
    },
    // 初始化 换表操作数据
    initChangeMeterOption() {
      this.$set(this.model, 'meterOldMachineSumFlow', '') // 旧表机械读数
      this.$set(this.model, 'whetherSettlementOldTable', '') // 是否旧表机械读数结算
      this.$set(this.model, 'meterUserAccountNumAfterChange', '') // 剩余金额
      this.$set(this.model, 'resolvedPictureFront', '') // 处理前图片
      this.$set(this.model, 'resolvedPictureOpposite', '') // 处理后图片

      this.$set(this.model, 'meterStartNum', '') // 新表开始计费读数
      this.$set(this.model, 'payOrNot', 0) // 是否收费
      this.$set(this.model, 'infoPicture', '') // 支付凭证
      this.$set(this.model, 'remark', '') // 支付凭证
    },
    onChange(value) {
      // value 是级联选择器的完整路径数组，如 ["1", "2", "3"]
      if (value && value.length > 0) {
        // 获取最后一层的值
        const lastValue = value[value.length - 1]
        // 存储到 formReason 字段
        this.$set(this.model, 'changingMeterReason', lastValue)
      }
    },
    displayRender({ labels }) {
      return labels[labels.length - 1]
    },
    // 根据最后一层值查找完整路径
    findCascaderPath(leafValue) {
      const findPathRecursive = (node, path = []) => {
        // 判断当前节点是否匹配
        if (String(node.value) === String(leafValue)) {
          return [...path, node.value] // 返回当前路径
        }

        // 如果有子节点，继续递归查找
        if (node.children) {
          for (let child of node.children) {
            const result = findPathRecursive(child, [...path, node.value])
            if (result) {
              return result // 找到路径，返回
            }
          }
        }

        return null // 没找到，返回 null
      }

      // 遍历 options，查找路径
      for (let item of this.options) {
        const result = findPathRecursive(item)
        if (result) {
          return result // 找到路径，返回
        }
      }

      return [] // 如果没找到路径，返回空数组
    },
    whetherSettlementOldTableChange() {
      if (this.model.whetherSettlementOldTable == 1 && this.model.meterOldMachineSumFlow != null) {
        this.meterOldMachineSumFlowInput()
      } else {
        this.$set(this.model, 'meterUserAccountNumAfterChange', null)
      }
    },
    payOrNotChange() {
      this.model.infoPicture = ''
    },
    ticketsTypeChange(value){
      if(this.model.ticketsType == 11){
        this.model.repairCreateOrderUserType = 0
        let userinfo = Vue.ls.get(USER_INFO)
        if(userinfo != null){
          this.$set(this.model,"repairName",userinfo?.realname)
          this.$set(this.model,"repairPhone",userinfo?.phone)
        }

      }
    },
    handleCancel2() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
}
</script>
<style lang="less" scoped>
//   .ant-divider-horizontal.ant-divider-with-text-left::before,
//   .ant-divider-horizontal.ant-divider-with-text-left::after{
//     border-width: 2px;
//     border-color: #999;
//   }
/deep/.detail-list .content {
  line-height: normal;
}
.form-card-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
